import get from './components/get';
import dispatch from './components/dispatch';
import Assets from './components/assets';
if (!window.$ACE) {
  window.$ACE = {};
}
const ACE = {
  ...window.$ACE,
  get,
  Assets,
};
ACE.dispatch = dispatch.bind(ACE);
window.$ACE = ACE;



// WEBPACK FOOTER //
// ./src/init.js